import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Backdrop, Box, Button, CircularProgress, Grid, Typography, TextField } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import CheckPermissions from '../../../authorization/authorization';
import BasicTable from '../../../components/basicTable/basicTable';
import { cfpBaseUrl } from '../../../network/urls';
import { allCompaniesAPI, convertDatewithTime } from '../../../services/Functions';
import { tableStyle } from '../../../style/common';
import '../OrganizationManagement.scss';
import UserIconImage from '../../../images/user.jpg';

export default function CompanyManagementTable(props) {
    //#region 
    const [companyTODataGrid, setCompanyTODataGrid] = useState([]);
    const [open, setOpen] = useState(false);
    const [open2, setopen2] = useState(false);
    const [dialogRowData, setDialogRowData] = React.useState({});
    const [dltCompany, setDltCompany] = useState()
    const [tableCompany, setTableCompany] = useState([]);
    const [viewBackdrop, setViewBackdrop] = useState(false);
    const navigate = useNavigate();
    const { token, permissions } = useSelector((state) => state.auth);

    //#endregion
    useEffect(() => {
        apiToDataGridConversion()
    }, [tableCompany]);

    useEffect(() => {
        const callAllCompanies = async () => {
            setViewBackdrop(true)
            let companiesList = await allCompaniesAPI(token, cfpBaseUrl)
            if (companiesList) {
                setTableCompany(companiesList)
            }
            setViewBackdrop(false);
        }
        callAllCompanies()
    }, [])

    const filterCompany = (companyCode) => {
        let itemFound = tableCompany.find(item => item.companyCode === companyCode)
        return itemFound;
    }

    const handleClose = () => {
        setOpen(false);
    };

    const handleClose2 = () => {
        setopen2(false);
    };

    const onDelete = async () => {
        setViewBackdrop(true)
        var formdata = new FormData();
        formdata.append("companyCode", dltCompany);
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);

        var requestOptions = {
            method: 'POST',
            body: formdata,
            headers: myHeaders,
            redirect: 'follow',
        };

        await fetch(cfpBaseUrl + "customerFaciliationPortal/deleteCompany", requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.status === '200') {
                    let myArray = [...tableCompany]
                    let index = myArray.findIndex(obj => obj.companyCode == dltCompany);
                    if (index != -1) {
                        myArray.splice(index, 1);
                        setTableCompany(myArray)
                    }
                }
                else {
                }

            })
            .catch(error => console.log('error', error));
        handleClose2();
        setViewBackdrop(false)
    }

    const tblColumns = [
        { field: "id", headerName: 'Code', headerAlign: 'start', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "completename", headerName: 'Complete Name', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        // { field: "bank_name", headerName: 'Bank Name', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        // { field: "erp_code", headerName: 'ERP Code', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        // { field: "capital_code", headerName: 'Cap. Cost Acc. No.', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        // { field: "security_code", headerName: 'Sec. Cost Acc. No.', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        // { field: "created_by", headerName: 'Creator', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle  },
        // { field: "created_at", headerName: 'Created', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle  },
        // { field: "updated_by", headerName: 'Updator', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle  },
        // { field: "updated_at", headerName: 'Updated', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle  },
        {
            headerName: "Action",
            sortable: false,
            field: 'buttons',
            align: 'center',
            headerStyle: tableStyle.headerStyle,
            headerCellStyle: tableStyle.headerCellStyle,
            rowCellStyle: tableStyle.rowCellStyle,
            renderCell: (params) => {

                const onViewCompany = (e) => {
                    e.stopPropagation();
                    const item = filterCompany(params.id);
                    setDialogRowData(item);
                    setOpen(true);

                };

                const onDeleteCompany = (e) => {
                    e.stopPropagation(); // don't select this row after clicking
                    setopen2(true);
                    setDltCompany(params.id)
                };

                const onEditCompany = (e) => {
                    e.stopPropagation(); // don't select this row after clicking
                    const companyToEdit = filterCompany(params.id);
                    navigate('/company-management/update-company', { state: { companyToEdit } })
                };

                return (
                    <>
                        <Box>
                            {
                                CheckPermissions(permissions, 'Organization Management', 'Company Management', 'Read') ?
                                    <IconButton onClick={onViewCompany} aria-label="delete" size="small" sx={{ margin: 0.4, padding: 0 }}>
                                        <VisibilityIcon sx={{ color: 'skyblue' }} fontSize='inherit' />
                                    </IconButton> : null
                            }
                            {
                                CheckPermissions(permissions, 'Organization Management', 'Company Management', 'Update') ?
                                    <IconButton onClick={onEditCompany} aria-label="delete" size="small" sx={{ margin: 0.4, padding: 0 }}>
                                        <EditIcon fontSize="inherit" sx={{ color: 'blue' }} />
                                    </IconButton> : null
                            }
                            {
                                CheckPermissions(permissions, 'Organization Management', 'Company Management', 'Delete') ?
                                    <IconButton aria-label="delete" size="small" sx={{ margin: 0, padding: 0 }} onClick={onDeleteCompany}>
                                        <DeleteIcon fontSize="inherit" sx={{ color: 'red' }} />
                                    </IconButton> : null
                            }
                        </Box>
                    </>
                )
            }
        }
    ]

    const apiToDataGridConversion = () => {
        const myArray = tableCompany
        const tempArray = []
        if (myArray) {
            myArray.forEach((item) => {
                const dataGridObject = {
                    "id": item.companyCode,
                    "completename": item.companyName,
                    "roles": item.roleName,
                    "bank_name": item.compBankName ? item.compBankName : '-',
                    "erp_code": item.compErpCode ? item.compErpCode : '-',
                    "capital_code": item.compCapitalCostAccountNo ? item.compCapitalCostAccountNo : '-',
                    "security_code": item.compSecurityAccountNo ? item.compSecurityAccountNo : '-'
                }
                tempArray.push(dataGridObject)
            })
        }
        else {
            const dataGridObject = {
                "id": ' ',
                "connectionType": '',
                "applicantName": ' ',
                "applicantCNIC": ' ',
            }
            tempArray.push(dataGridObject)
        }
        setCompanyTODataGrid(tempArray);
    }

    return (
        <>
            <Box className='form-box'>
                <h3 className='page-title'>Company Management</h3>
                <Box className='application-table' >
                    <BasicTable
                        data={companyTODataGrid}
                        columns={tblColumns}
                        sx={tableStyle}
                        rowHeight={37.5}
                        pageSize={18}
                        rowsPerPageOptions={[18, 30, 60]}
                        rowsPageOption={false}
                        getRowStyle={(params) => {
                            return params.indexRelativeToCurrentPage % 2 === 0 ? tableStyle.evenRow : tableStyle.oddRow
                        }} />
                </Box>
            </Box>

            {/* <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                // fullWidth={true}
                // maxWidth={'sm'}
                PaperProps={{ sx: { width: '30%' } }}
            >
                <DialogTitle id="alert-dialog-title" className="dialog-title">
                    <IconButton onClick={handleClose} sx={{ position: "relative", float: 'right' }}>
                        <CloseIcon />
                    </IconButton>
                    <Typography sx={{ fontWeight: 'bold' }}>Company Details</Typography>
                </DialogTitle>
                <DialogContent className='dialog-content'>
                    <Box sx={{ display: 'flex', flexDirection: 'row', alignitem: 'center', justifyContent: 'space-between', }}>
                        <Box sx={{ marginTop: '35px' }}>
                            <Typography sx={{ fontWeight: 'bold' }}>Profile Picture</Typography>
                        </Box>˚º
                        <Box >
                            <img src={dialogRowData.companyLogo} height='100' width='100'
                                alt='avatar' />
                        </Box>
                    </Box>
                    <DialogContentText id="alert-dialog-description">
                        <hr />
                        <Grid className='content-grid' sx={{ mt: '17px', display: 'flex', flexDirection: "column" }}>
                            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5>ID:</h5><span>{dialogRowData.companyCode ? dialogRowData.companyCode : '-'}</span>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5>Name:</h5><p>{dialogRowData.companyName ? dialogRowData.companyName : '-'}</p>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5>Latitude:</h5><p>{dialogRowData.latitude ? dialogRowData.latitude : '-'}</p>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5>Longitude:</h5><p>{dialogRowData.longitude ? dialogRowData.longitude : '-'}</p>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5>status:</h5><p>{dialogRowData.status === '0' ? 'Active' : 'InActive'}</p>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5 >Created by:</h5><p>{dialogRowData.createdBy ? dialogRowData.createdBy : '-'}</p>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5 >Created at:</h5><p>{dialogRowData.createdDate ? convertDatewithTime(dialogRowData.createdDate) : '-'}</p>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5 >Last Updated By:</h5><p>{dialogRowData.updateBy ? dialogRowData.updateBy : '-'}</p>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5 >Last Updated At:</h5><p>{dialogRowData.updatedDate ? convertDatewithTime(dialogRowData.updatedDate) : '-'}</p>
                                </Box>
                                <Box sx={{ marginTop: '35px' }}>
                                    <Typography sx={{ fontWeight: 'bold' }}>Contact Person 1</Typography>
                                </Box>
                                <hr />
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5 >Name:</h5><p>{dialogRowData.cp1Name ? dialogRowData.cp1Name : '-'}</p>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5 >Phone:</h5><p>{dialogRowData.cp1phone ? dialogRowData.cp1phone : '-'}</p>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5 >Mobile:</h5><p>{dialogRowData.cp1Mobile ? dialogRowData.cp1Mobile : '-'}</p>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5 >Email:</h5><p>{dialogRowData.cp1Email ? dialogRowData.cp1Email : '-'}</p>
                                </Box>
                                <Box sx={{ marginTop: '35px' }}>
                                    <Typography sx={{ fontWeight: 'bold' }}>Contact Person 2</Typography>
                                </Box>
                                <hr />
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5 >Name:</h5><p>{dialogRowData.cp2Name ? dialogRowData.cp2Name : '-'}</p>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5 >Phone:</h5><p>{dialogRowData.cp2phone ? dialogRowData.cp2phone : '-'}</p>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5 >Mobile:</h5><p>{dialogRowData.cp2Mobile ? dialogRowData.cp2Mobile : '-'}</p>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5 >Email:</h5><p>{dialogRowData.cp2Email ? dialogRowData.cp2Email : '-'}</p>
                                </Box>
                                <Box sx={{ marginTop: '35px' }}>
                                    <Typography sx={{ fontWeight: 'bold' }}>Bank Details</Typography>
                                </Box>
                                <hr />
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5 >Bank Name:</h5><p>{dialogRowData.compBankName ? dialogRowData.compBankName : '-'}</p>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5 >ERP Code:</h5><p>{dialogRowData.compErpCode ? dialogRowData.compErpCode : '-'}</p>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5 >Capital Cost Account No.:</h5><p>{dialogRowData.compCapitalCostAccountNo ? dialogRowData.compCapitalCostAccountNo : '-'}</p>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5 >Security Cost Account No.:</h5><p>{dialogRowData.compSecurityAccountNo ? dialogRowData.compSecurityAccountNo : '-'}</p>
                                </Box>
                            </Box>
                        </Grid>
                    </DialogContentText>
                </DialogContent>
            </Dialog > */}
            <Dialog
                open={open}
                onClose={handleClose}
                fullWidth
                maxWidth="sm"
                PaperProps={{ sx: { borderRadius: 3, maxWidth: 1000 } }}
                className="alert-popups"
            >
                <DialogTitle
                    sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                    className="dialog-title"
                >
                    Company Details
                    <IconButton onClick={handleClose} sx={{ color: 'black' }}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent className="dialog-content">
                    <DialogContentText sx={{ minHeight: 300 }}>
                        <Grid container spacing={1} sx={{ padding: '20px' }}>
                            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                                <Box sx={{ p: 1, border: '2px solid #006ad1', borderRadius: 2 }}>
                                    <img
                                        src={dialogRowData.companyLogo || UserIconImage}
                                        alt="Company Logo"
                                        style={{
                                            width: 120,
                                            height: 120,
                                            objectFit: 'cover',
                                        }}
                                        onError={(e) => (e.target.src = UserIconImage)}
                                    />
                                </Box>
                            </Grid>

                            <Grid item xs={12} sx={{ marginTop: '17px' }}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sx={{ backgroundColor: '#d5e5ff', padding: '5px', fontSize: '1.25rem' }}>
                                        <h4 style={{ color: '#006ad1' }}>Company Information</h4>
                                    </Grid>

                                    {[
                                        { label: 'ID', value: dialogRowData.companyCode },
                                        { label: 'Name', value: dialogRowData.companyName },
                                        { label: 'Latitude', value: dialogRowData.latitude },
                                        { label: 'Longitude', value: dialogRowData.longitude },
                                        {
                                            label: 'Status',
                                            value: dialogRowData.status === '0' ? 'Active' : 'Inactive',
                                        },
                                        { label: 'Created By', value: dialogRowData.createdBy },
                                        {
                                            label: 'Created At',
                                            value: convertDatewithTime(dialogRowData.createdDate),
                                        },
                                        { label: 'Last Updated By', value: dialogRowData.updateBy },
                                        {
                                            label: 'Last Updated At',
                                            value: convertDatewithTime(dialogRowData.updatedDate),
                                        },
                                    ].map((item, index) => (
                                        <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                                            <label style={{ fontWeight: 600 }}>{item.label}</label>
                                            <TextField
                                                value={item.value || '-'}
                                                fullWidth
                                                disabled
                                                sx={{
                                                    mt: 0.5,
                                                    '.MuiInputBase-input': { height: '1.2rem' },
                                                }}
                                            />
                                        </Grid>
                                    ))}
                                </Grid>
                            </Grid>

                            {/* Contact Person 1 */}
                            <Grid item xs={12}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sx={{ mt: 3, backgroundColor: '#d5e5ff', padding: '5px', fontSize: '1.25rem' }}>
                                        <h4 style={{ color: '#006ad1' }}>Contact Person 1</h4>
                                    </Grid>
                                    {[
                                        { label: 'Name', value: dialogRowData.cp1Name },
                                        { label: 'Phone', value: dialogRowData.cp1phone },
                                        { label: 'Mobile', value: dialogRowData.cp1Mobile },
                                        { label: 'Email', value: dialogRowData.cp1Email },
                                    ].map((item, index) => (
                                        <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                                            <label style={{ fontWeight: 600 }}>{item.label}</label>
                                            <TextField
                                                value={item.value || '-'}
                                                fullWidth
                                                disabled
                                                sx={{
                                                    mt: 0.5,
                                                    '.MuiInputBase-input': { height: '1.2rem' },
                                                }}
                                            />
                                        </Grid>
                                    ))}
                                </Grid>
                            </Grid>

                            {/* Contact Person 2 */}
                            <Grid item xs={12}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sx={{ mt: 3, backgroundColor: '#d5e5ff', padding: '5px', fontSize: '1.25rem' }}>
                                        <h4 style={{ color: '#006ad1' }}>Contact Person 2</h4>
                                    </Grid>
                                    {[
                                        { label: 'Name', value: dialogRowData.cp2Name },
                                        { label: 'Phone', value: dialogRowData.cp2phone },
                                        { label: 'Mobile', value: dialogRowData.cp2Mobile },
                                        { label: 'Email', value: dialogRowData.cp2Email },
                                    ].map((item, index) => (
                                        <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                                            <label style={{ fontWeight: 600 }}>{item.label}</label>
                                            <TextField
                                                value={item.value || '-'}
                                                fullWidth
                                                disabled
                                                sx={{
                                                    mt: 0.5,
                                                    '.MuiInputBase-input': { height: '1.2rem' },
                                                }}
                                            />
                                        </Grid>
                                    ))}
                                </Grid>
                            </Grid>

                            {/* Bank Details */}
                            <Grid item xs={12}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sx={{ mt: 3, backgroundColor: '#d5e5ff', padding: '5px', fontSize: '1.25rem' }}>
                                        <h4 style={{ color: '#006ad1' }}>Bank Details</h4>
                                    </Grid>
                                    {[
                                        { label: 'Account Title', value: dialogRowData.accountTitle },
                                        { label: 'Account Number', value: dialogRowData.accountNumber },
                                        { label: 'Bank Name', value: dialogRowData.bankName },
                                        { label: 'Bank Branch Code', value: dialogRowData.bankBranchCode },
                                    ].map((item, index) => (
                                        <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                                            <label style={{ fontWeight: 600 }}>{item.label}</label>
                                            <TextField
                                                value={item.value || '-'}
                                                fullWidth
                                                disabled
                                                sx={{
                                                    mt: 0.5,
                                                    '.MuiInputBase-input': { height: '1.2rem' },
                                                }}
                                            />
                                        </Grid>
                                    ))}
                                </Grid>
                            </Grid>

                            
                        </Grid>
                    </DialogContentText>
                </DialogContent>
            </Dialog>


            <Dialog
                open={open2}
                onClose={handleClose2}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {" Are you sure to delete this record"}
                </DialogTitle>
                <DialogActions>
                    <Button onClick={handleClose2}>Cancel</Button>
                    <Button onClick={onDelete} autoFocus>
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Backdrop */}
            < Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                open={viewBackdrop}
            >
                <CircularProgress color="inherit" />
            </Backdrop >
        </>
    )
}
